export const staticLevelData = [
    {
        level_no: 1,
        games: []
    },
    {
        level_no: 2,
        games: []
    },
    {
        level_no: 3,
        games: []
    },
    {
        level_no: 4,
        games: []
    },
    {
        level_no: 5,
        games: []
    },
    {
        level_no: 6,
        games: []
    }
]